// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { MainSidebar } from '../components/mainsidebar'
import { SecSidebar } from '../components/secsidebar'

export class Performance extends Component {
    constructor(props) {
        super(props)

        this.state = {
            workers: [],
            assignmentsTotal: null,
            assignmentsCompleted: null,
            assignmentsCompletionRate: null,
            assignmentsInProgress: null,
            assignmentsInProgressRate: null,
            assignmentsNotStarted: null,
            assignmentsNotStartedRate: null,
            activeModules: [],
            activeWorkerId: 0,
            activeWorkerName: "",
            activeModuleName: ""
        }

        this.init = this.init.bind(this)
        this.handleLoadWorkers = this.handleLoadWorkers.bind(this)
        this.handleActiveWorker = this.handleActiveWorker.bind(this)
        this.handleActiveModule = this.handleActiveModule.bind(this)

        this.init()
    }

    init() {
        if (!window.sessionStorage.getItem('authToken')) {
            console.log("not logged in")
            this.props.router.push('/login')
            return
        }

        if (this.props.appData.authToken === '') {
            let storedData = window.sessionStorage

            let data = {
                profileType: storedData.profileType,
                loginStatus: storedData.loginStatus,
                authToken: storedData.authToken,
                id: storedData.uid,
                admin_first_name: storedData.fname,
                admin_last_name: storedData.lname,
                name: storedData.company,
                company: storedData.company,
                address: storedData.address,
                license_count: storedData.licenseCount,
                globalModules: JSON.parse(storedData.globalModules)
            }

            if ('activeModules' in storedData) {
                this.state = {
                    workers: JSON.parse(storedData.workers),
                    activeModules: JSON.parse(storedData.activeModules),
                    activeWorkerName: storedData.activeWorkerName,
                    activeWorkerId: storedData.activeWorkerId,
                    activeModuleName: storedData.activeModuleName
                }
            }
            else {
                this.state = {
                    activeWorkerName: storedData.activeWorkerName,
                    activeWorkerId: storedData.activeWorkerId,
                    activeModuleName: storedData.activeModuleName
                }
            }

            this.props.handleProviderDataUpdateFromSessionStorage(data)
        }
    }

    handleLoadWorkers(workers) {
        // Calculate provider-wide completion rate figures
        let assignmentsTotal = 0
        let assignmentsCompleted = 0
        let assignmentsCompletionRate = 0
        let assignmentsInProgress = 0
        let assignmentsInProgressRate = 0
        let assignmentsNotStarted = 0
        let assignmentsNotStartedRate = 0
        let worker = null

        for (let i = 0; i < workers.length; i++) {
            worker = workers[i]
            assignmentsTotal += worker.enabler_modules.length

            for (let j = 0; j < worker.enabler_modules.length; j++) {
                if (worker.enabler_modules[j].completed) {
                    assignmentsCompleted++
                }
                else if (worker.enabler_modules[j].average_strikes !== null) {
                    assignmentsInProgress++
                }
                else {
                    assignmentsNotStarted++
                }
            }
        }

        if (assignmentsTotal > 0) {
            assignmentsCompletionRate = Math.round(assignmentsCompleted / assignmentsTotal * 100.0)
            assignmentsInProgressRate = Math.round(assignmentsInProgress / assignmentsTotal * 100.0)
            assignmentsNotStartedRate = Math.round(assignmentsNotStarted / assignmentsTotal * 100.0)
        }

        this.setState({
            workers,
            assignmentsTotal: assignmentsTotal,
            assignmentsCompleted: assignmentsCompleted,
            assignmentsCompletionRate: assignmentsCompletionRate,
            assignmentsInProgress: assignmentsInProgress,
            assignmentsInProgressRate: assignmentsInProgressRate,
            assignmentsNotStarted: assignmentsNotStarted,
            assignmentsNotStartedRate: assignmentsNotStartedRate,
        })

        window.sessionStorage.setItem("workers", JSON.stringify(workers))
    }

    handleActiveWorker(activeWorkerId) {
        let activeWorker = this.state.workers.filter(worker => {
            return worker.id === Number(activeWorkerId)
        })[0]

        activeWorker.enabler_modules.sort((a, b) => (a.name < b.name) ? -1 : 1)

        this.setState({
            activeModules: activeWorker.enabler_modules,
            activeWorkerName: activeWorker.first_name + " " + activeWorker.last_name,
            activeWorkerId: activeWorkerId
        })

        window.sessionStorage.setItem("activeModules", JSON.stringify(activeWorker.enabler_modules))
        window.sessionStorage.setItem("activeWorkerName", activeWorker.first_name + " " + activeWorker.last_name)
        window.sessionStorage.setItem("activeWorkerId", activeWorkerId)
    }

    handleActiveModule(moduleName) {
        this.setState({
            activeModuleName: moduleName
        })

        window.sessionStorage.setItem("activeModuleName", moduleName)
    }


    render() {
        let childWithProps = React.Children.map(this.props.children, child => {
            return (
                React.cloneElement(child, {
                    appData: this.props.appData,
                    env: this.props.env,
                    workers: this.state.workers,
                    assignmentsTotal: this.state.assignmentsTotal,
                    assignmentsCompleted: this.state.assignmentsCompleted,
                    assignmentsCompletionRate: this.state.assignmentsCompletionRate,
                    assignmentsInProgress: this.state.assignmentsInProgress,
                    assignmentsInProgressRate: this.state.assignmentsInProgressRate,
                    assignmentsNotStarted: this.state.assignmentsNotStarted,
                    assignmentsNotStartedRate: this.state.assignmentsNotStartedRate,
                    authToken: this.props.appData.authToken,
                    activeWorkerId: this.state.activeWorkerId,
                    activeWorkerName: this.state.activeWorkerName,
                    activeModuleName: this.state.activeModuleName,
                    activeModules: this.state.activeModules,
                    handleLoadWorkers: this.handleLoadWorkers,
                    handleActiveWorker: this.handleActiveWorker,
                    handleActiveModule: this.handleActiveModule
                })
            )
        })

        return (
            <div className="performance-container workforce-container page-container">
                <MainSidebar
                    profileType={this.props.appData.profileType}
                    logout={this.props.handleLoginStateChange}
                    profile={1}
                    appData={this.props.appData}
                />

                <SecSidebar
                    profileType={this.props.appData.profileType}
                    menuItemsKey={"workforce"}
                    profile={1}
                />

                <div className="main-body" >
                    {childWithProps}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/performance.js